import { MAIN_QUESTS_GROUP } from "@/constants";
import type { Quest, QuestGroup } from "@ui-kit/QuestList";

const inMatch3QuestsList: Quest[] = [
  {
    type: "custom",
    key: "follow",
    icon: "Add",
    label: "Follow this game",
    caption: "Get exclusive content",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "c6c92500-1667-4318-a925-a3a8d9c7d3af-wishlist-added",
    ruleId: "c6c92500-1667-4318-a925-a3a8d9c7d3af-wishlist",
  },
  {
    type: "link",
    key: "x-v2",
    icon: "X",
    label: "Follow IN - match3 on X",
    caption: "Don't miss a tweet",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "c6c92500-1667-4318-a925-a3a8d9c7d3af-twitter-event",
    ruleId: "c6c92500-1667-4318-a925-a3a8d9c7d3af-twitter",
    linkUrl: "https://x.com/in_ongame",
  },
  {
    type: "link",
    key: "telegram",
    icon: "Telegram",
    label: "Subscribe to Telegram",
    caption: "Subscribe to our Telegram community",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "c6c92500-1667-4318-a925-a3a8d9c7d3af-website-telegram-event",
    ruleId: "c6c92500-1667-4318-a925-a3a8d9c7d3af-website-telegram",
    linkUrl: "https://t.me/inongame",
  },
  {
    type: "link",
    key: "telegram-v2",
    icon: "Telegram",
    label: "Join Telegram Chat",
    caption: "Join our massively growing community",
    linkUrl: "https://t.me/inongame_chat",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId:
      "c6c92500-1667-4318-a925-a3a8d9c7d3af-inmatch3-telegram-validation-completed",
    ruleId: "inmatch3-telegram-validation",
  },
  {
    type: "link",
    key: "website",
    icon: "ApplicationWeb",
    label: "Download and play IN - match3",
    caption: "Play the game and earn rewards",
    linkUrl: "https://ongame.dev/play",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "c6c92500-1667-4318-a925-a3a8d9c7d3af-website-download-game-event",
    ruleId: "c6c92500-1667-4318-a925-a3a8d9c7d3af-website-download-game",
  },
  {
    type: "link",
    key: "website",
    icon: "ApplicationWeb",
    label: "Subscribe to YouTube channel",
    caption: "Stay up to date with the latest content",
    linkUrl: "https://www.youtube.com/@ongameIn",
    increase: 10,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "c6c92500-1667-4318-a925-a3a8d9c7d3af-website-youtube-event",
    ruleId: "c6c92500-1667-4318-a925-a3a8d9c7d3af-website-youtube",
  },
];

export const inMatch3SocialEngagementQuests: Quest[] = [
  {
    type: "custom",
    key: "social-engagement",
    icon: "SupportChat",
    label: "Post a message and engage in the Telegram channel daily",
    caption: "Earn gems everyday",
    increase: 10,
    badgeIcon: "ImxRewards",
    recurring: true,
    badgeTemplate: "+<increase> <icon> Gems",
    eventId:
      "c6c92500-1667-4318-a925-a3a8d9c7d3af-inmatch3-telegram-social-engagement-completed",
    ruleId: "inmatch3-telegram-social-engagement",
  },
];

export const inMatch3Quests: QuestGroup[] = [
  {
    key: "level-1",
    header: {
      image: "",
      description: "",
      title: "Learn and connect",
    },
    totalGemsGranted: 60,
    hideOnCompletion: true,
    lockedUntilPrevious: false,
    quests: inMatch3QuestsList,
  },
  {
    key: "social-engagement",
    header: {
      image: "",
      description: "",
      title: "Social Engagement",
    },
    nextQuest: {
      url: "/games/ravenquest",
      title: "Thanks for getting involved",
      label: "Want more? Check out RavenQuest",
      caption: "Earn additional rewards and support more games",
    },
    totalGemsGranted: 10,
    quests: inMatch3SocialEngagementQuests,
    hideOnCompletion: false,
    lockedUntilPrevious: false,
    questGroup: MAIN_QUESTS_GROUP,
  },
];
